import { render, staticRenderFns } from "./WhatsappEmbeddedSignup.vue?vue&type=template&id=0a5b183d&"
import script from "./WhatsappEmbeddedSignup.vue?vue&type=script&lang=js&"
export * from "./WhatsappEmbeddedSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports